import * as React from "react";
import { useRoute } from "../../../routing/router.ts";
import { NavItemData, onNavClick } from "../nav.tsx";
import { useCommonDialogs } from "../../CommonDialogsProvider.tsx";

interface Props {
  item: NavItemData;
}

/** A link for the lists, a button for Search and More, which open something over the page. */
export const BottomNavItem: React.FC<Props> = ({ item }) => {
  const route = useRoute();
  const isSelected = item.getIsSelected({ route });
  const commonDialogs = useCommonDialogs();
  const content = (
    <>
      {item.icon}
      {item.label}
    </>
  );
  if (!item.href)
    return (
      <button
        type="button"
        className="bottom-nav-item"
        aria-current={isSelected ? "page" : undefined}
        onClick={onNavClick(item, commonDialogs)}
      >
        {content}
      </button>
    );
  return (
    <a
      className="bottom-nav-item"
      href={item.href}
      aria-current={isSelected ? "page" : undefined}
      onClick={onNavClick(item, commonDialogs)}
    >
      {content}
    </a>
  );
};
